// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.0
// source: roboverse_platform_protos/statekeeping/Reported/Drone/DJI/DroneOSD.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Duration } from "../../../../../google/protobuf/duration";
import { Timestamp } from "../../../../../google/protobuf/timestamp";
import { Storage } from "../../__Common/Storage";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported.Drone.DJI";

/** based on https://developer.dji.com/doc/cloud-api-tutorial/en/api-reference/pilot-to-cloud/mqtt/others/aircraft/properties.html */

/** Camera: 0–3 */
export enum CameraMode {
  CAMERA_MODE_CAPTURING = 0,
  CAMERA_MODE_RECORDING = 1,
  CAMERA_MODE_SMART_LOW_LIGHT = 2,
  CAMERA_MODE_PANORAMIC_PHOTOGRAPHY = 3,
  UNRECOGNIZED = -1,
}

export function cameraModeFromJSON(object: any): CameraMode {
  switch (object) {
    case 0:
    case "CAMERA_MODE_CAPTURING":
      return CameraMode.CAMERA_MODE_CAPTURING;
    case 1:
    case "CAMERA_MODE_RECORDING":
      return CameraMode.CAMERA_MODE_RECORDING;
    case 2:
    case "CAMERA_MODE_SMART_LOW_LIGHT":
      return CameraMode.CAMERA_MODE_SMART_LOW_LIGHT;
    case 3:
    case "CAMERA_MODE_PANORAMIC_PHOTOGRAPHY":
      return CameraMode.CAMERA_MODE_PANORAMIC_PHOTOGRAPHY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CameraMode.UNRECOGNIZED;
  }
}

export function cameraModeToJSON(object: CameraMode): string {
  switch (object) {
    case CameraMode.CAMERA_MODE_CAPTURING:
      return "CAMERA_MODE_CAPTURING";
    case CameraMode.CAMERA_MODE_RECORDING:
      return "CAMERA_MODE_RECORDING";
    case CameraMode.CAMERA_MODE_SMART_LOW_LIGHT:
      return "CAMERA_MODE_SMART_LOW_LIGHT";
    case CameraMode.CAMERA_MODE_PANORAMIC_PHOTOGRAPHY:
      return "CAMERA_MODE_PANORAMIC_PHOTOGRAPHY";
    case CameraMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Photo state: 0–1 */
export enum PhotoState {
  PHOTO_STATE_IDLE = 0,
  PHOTO_STATE_CAPTURING_PHOTO = 1,
  UNRECOGNIZED = -1,
}

export function photoStateFromJSON(object: any): PhotoState {
  switch (object) {
    case 0:
    case "PHOTO_STATE_IDLE":
      return PhotoState.PHOTO_STATE_IDLE;
    case 1:
    case "PHOTO_STATE_CAPTURING_PHOTO":
      return PhotoState.PHOTO_STATE_CAPTURING_PHOTO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PhotoState.UNRECOGNIZED;
  }
}

export function photoStateToJSON(object: PhotoState): string {
  switch (object) {
    case PhotoState.PHOTO_STATE_IDLE:
      return "PHOTO_STATE_IDLE";
    case PhotoState.PHOTO_STATE_CAPTURING_PHOTO:
      return "PHOTO_STATE_CAPTURING_PHOTO";
    case PhotoState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Recording state: 0–1 */
export enum RecordingState {
  RECORDING_STATE_IDLE = 0,
  RECORDING_STATE_RECORDING = 1,
  UNRECOGNIZED = -1,
}

export function recordingStateFromJSON(object: any): RecordingState {
  switch (object) {
    case 0:
    case "RECORDING_STATE_IDLE":
      return RecordingState.RECORDING_STATE_IDLE;
    case 1:
    case "RECORDING_STATE_RECORDING":
      return RecordingState.RECORDING_STATE_RECORDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RecordingState.UNRECOGNIZED;
  }
}

export function recordingStateToJSON(object: RecordingState): string {
  switch (object) {
    case RecordingState.RECORDING_STATE_IDLE:
      return "RECORDING_STATE_IDLE";
    case RecordingState.RECORDING_STATE_RECORDING:
      return "RECORDING_STATE_RECORDING";
    case RecordingState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Position fixing: 0–3 */
export enum FixingState {
  FIXING_STATE_NOT_STARTED = 0,
  FIXING_STATE_FIXING = 1,
  FIXING_STATE_FIXING_SUCCESSFUL = 2,
  FIXING_STATE_FIXING_FAILED = 3,
  UNRECOGNIZED = -1,
}

export function fixingStateFromJSON(object: any): FixingState {
  switch (object) {
    case 0:
    case "FIXING_STATE_NOT_STARTED":
      return FixingState.FIXING_STATE_NOT_STARTED;
    case 1:
    case "FIXING_STATE_FIXING":
      return FixingState.FIXING_STATE_FIXING;
    case 2:
    case "FIXING_STATE_FIXING_SUCCESSFUL":
      return FixingState.FIXING_STATE_FIXING_SUCCESSFUL;
    case 3:
    case "FIXING_STATE_FIXING_FAILED":
      return FixingState.FIXING_STATE_FIXING_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FixingState.UNRECOGNIZED;
  }
}

export function fixingStateToJSON(object: FixingState): string {
  switch (object) {
    case FixingState.FIXING_STATE_NOT_STARTED:
      return "FIXING_STATE_NOT_STARTED";
    case FixingState.FIXING_STATE_FIXING:
      return "FIXING_STATE_FIXING";
    case FixingState.FIXING_STATE_FIXING_SUCCESSFUL:
      return "FIXING_STATE_FIXING_SUCCESSFUL";
    case FixingState.FIXING_STATE_FIXING_FAILED:
      return "FIXING_STATE_FIXING_FAILED";
    case FixingState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Position quality: 1–5, 10 */
export enum PositionQuality {
  POSITION_QUALITY_UNSPECIFIED = 0,
  POSITION_QUALITY_GEAR_1 = 1,
  POSITION_QUALITY_GEAR_2 = 2,
  POSITION_QUALITY_GEAR_3 = 3,
  POSITION_QUALITY_GEAR_4 = 4,
  POSITION_QUALITY_GEAR_5 = 5,
  POSITION_QUALITY_RTK_FIXED = 10,
  UNRECOGNIZED = -1,
}

export function positionQualityFromJSON(object: any): PositionQuality {
  switch (object) {
    case 0:
    case "POSITION_QUALITY_UNSPECIFIED":
      return PositionQuality.POSITION_QUALITY_UNSPECIFIED;
    case 1:
    case "POSITION_QUALITY_GEAR_1":
      return PositionQuality.POSITION_QUALITY_GEAR_1;
    case 2:
    case "POSITION_QUALITY_GEAR_2":
      return PositionQuality.POSITION_QUALITY_GEAR_2;
    case 3:
    case "POSITION_QUALITY_GEAR_3":
      return PositionQuality.POSITION_QUALITY_GEAR_3;
    case 4:
    case "POSITION_QUALITY_GEAR_4":
      return PositionQuality.POSITION_QUALITY_GEAR_4;
    case 5:
    case "POSITION_QUALITY_GEAR_5":
      return PositionQuality.POSITION_QUALITY_GEAR_5;
    case 10:
    case "POSITION_QUALITY_RTK_FIXED":
      return PositionQuality.POSITION_QUALITY_RTK_FIXED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PositionQuality.UNRECOGNIZED;
  }
}

export function positionQualityToJSON(object: PositionQuality): string {
  switch (object) {
    case PositionQuality.POSITION_QUALITY_UNSPECIFIED:
      return "POSITION_QUALITY_UNSPECIFIED";
    case PositionQuality.POSITION_QUALITY_GEAR_1:
      return "POSITION_QUALITY_GEAR_1";
    case PositionQuality.POSITION_QUALITY_GEAR_2:
      return "POSITION_QUALITY_GEAR_2";
    case PositionQuality.POSITION_QUALITY_GEAR_3:
      return "POSITION_QUALITY_GEAR_3";
    case PositionQuality.POSITION_QUALITY_GEAR_4:
      return "POSITION_QUALITY_GEAR_4";
    case PositionQuality.POSITION_QUALITY_GEAR_5:
      return "POSITION_QUALITY_GEAR_5";
    case PositionQuality.POSITION_QUALITY_RTK_FIXED:
      return "POSITION_QUALITY_RTK_FIXED";
    case PositionQuality.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Flight mode: 0–19 */
export enum FlightMode {
  FLIGHT_MODE_STANDBY = 0,
  FLIGHT_MODE_TAKEOFF_PREPARATION = 1,
  FLIGHT_MODE_TAKEOFF_PREPARATION_COMPLETED = 2,
  FLIGHT_MODE_MANUAL_FLIGHT = 3,
  FLIGHT_MODE_AUTOMATIC_TAKEOFF = 4,
  FLIGHT_MODE_WAYLINE_FLIGHT = 5,
  FLIGHT_MODE_PANORAMIC_PHOTOGRAPHY = 6,
  FLIGHT_MODE_INTELLIGENT_TRACKING = 7,
  FLIGHT_MODE_ADS_B_AVOIDANCE = 8,
  FLIGHT_MODE_AUTO_RETURNING_TO_HOME = 9,
  FLIGHT_MODE_AUTOMATIC_LANDING = 10,
  FLIGHT_MODE_FORCED_LANDING = 11,
  FLIGHT_MODE_THREE_BLADE_LANDING = 12,
  FLIGHT_MODE_UPGRADING = 13,
  FLIGHT_MODE_NOT_CONNECTED = 14,
  FLIGHT_MODE_APAS = 15,
  FLIGHT_MODE_VIRTUAL_STICK_STATE = 16,
  FLIGHT_MODE_LIVE_FLIGHT_CONTROLS = 17,
  FLIGHT_MODE_AIRBORNE_RTK_FIXING_MODE = 18,
  FLIGHT_MODE_DOCK_ADDRESS_SELECTING = 19,
  UNRECOGNIZED = -1,
}

export function flightModeFromJSON(object: any): FlightMode {
  switch (object) {
    case 0:
    case "FLIGHT_MODE_STANDBY":
      return FlightMode.FLIGHT_MODE_STANDBY;
    case 1:
    case "FLIGHT_MODE_TAKEOFF_PREPARATION":
      return FlightMode.FLIGHT_MODE_TAKEOFF_PREPARATION;
    case 2:
    case "FLIGHT_MODE_TAKEOFF_PREPARATION_COMPLETED":
      return FlightMode.FLIGHT_MODE_TAKEOFF_PREPARATION_COMPLETED;
    case 3:
    case "FLIGHT_MODE_MANUAL_FLIGHT":
      return FlightMode.FLIGHT_MODE_MANUAL_FLIGHT;
    case 4:
    case "FLIGHT_MODE_AUTOMATIC_TAKEOFF":
      return FlightMode.FLIGHT_MODE_AUTOMATIC_TAKEOFF;
    case 5:
    case "FLIGHT_MODE_WAYLINE_FLIGHT":
      return FlightMode.FLIGHT_MODE_WAYLINE_FLIGHT;
    case 6:
    case "FLIGHT_MODE_PANORAMIC_PHOTOGRAPHY":
      return FlightMode.FLIGHT_MODE_PANORAMIC_PHOTOGRAPHY;
    case 7:
    case "FLIGHT_MODE_INTELLIGENT_TRACKING":
      return FlightMode.FLIGHT_MODE_INTELLIGENT_TRACKING;
    case 8:
    case "FLIGHT_MODE_ADS_B_AVOIDANCE":
      return FlightMode.FLIGHT_MODE_ADS_B_AVOIDANCE;
    case 9:
    case "FLIGHT_MODE_AUTO_RETURNING_TO_HOME":
      return FlightMode.FLIGHT_MODE_AUTO_RETURNING_TO_HOME;
    case 10:
    case "FLIGHT_MODE_AUTOMATIC_LANDING":
      return FlightMode.FLIGHT_MODE_AUTOMATIC_LANDING;
    case 11:
    case "FLIGHT_MODE_FORCED_LANDING":
      return FlightMode.FLIGHT_MODE_FORCED_LANDING;
    case 12:
    case "FLIGHT_MODE_THREE_BLADE_LANDING":
      return FlightMode.FLIGHT_MODE_THREE_BLADE_LANDING;
    case 13:
    case "FLIGHT_MODE_UPGRADING":
      return FlightMode.FLIGHT_MODE_UPGRADING;
    case 14:
    case "FLIGHT_MODE_NOT_CONNECTED":
      return FlightMode.FLIGHT_MODE_NOT_CONNECTED;
    case 15:
    case "FLIGHT_MODE_APAS":
      return FlightMode.FLIGHT_MODE_APAS;
    case 16:
    case "FLIGHT_MODE_VIRTUAL_STICK_STATE":
      return FlightMode.FLIGHT_MODE_VIRTUAL_STICK_STATE;
    case 17:
    case "FLIGHT_MODE_LIVE_FLIGHT_CONTROLS":
      return FlightMode.FLIGHT_MODE_LIVE_FLIGHT_CONTROLS;
    case 18:
    case "FLIGHT_MODE_AIRBORNE_RTK_FIXING_MODE":
      return FlightMode.FLIGHT_MODE_AIRBORNE_RTK_FIXING_MODE;
    case 19:
    case "FLIGHT_MODE_DOCK_ADDRESS_SELECTING":
      return FlightMode.FLIGHT_MODE_DOCK_ADDRESS_SELECTING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FlightMode.UNRECOGNIZED;
  }
}

export function flightModeToJSON(object: FlightMode): string {
  switch (object) {
    case FlightMode.FLIGHT_MODE_STANDBY:
      return "FLIGHT_MODE_STANDBY";
    case FlightMode.FLIGHT_MODE_TAKEOFF_PREPARATION:
      return "FLIGHT_MODE_TAKEOFF_PREPARATION";
    case FlightMode.FLIGHT_MODE_TAKEOFF_PREPARATION_COMPLETED:
      return "FLIGHT_MODE_TAKEOFF_PREPARATION_COMPLETED";
    case FlightMode.FLIGHT_MODE_MANUAL_FLIGHT:
      return "FLIGHT_MODE_MANUAL_FLIGHT";
    case FlightMode.FLIGHT_MODE_AUTOMATIC_TAKEOFF:
      return "FLIGHT_MODE_AUTOMATIC_TAKEOFF";
    case FlightMode.FLIGHT_MODE_WAYLINE_FLIGHT:
      return "FLIGHT_MODE_WAYLINE_FLIGHT";
    case FlightMode.FLIGHT_MODE_PANORAMIC_PHOTOGRAPHY:
      return "FLIGHT_MODE_PANORAMIC_PHOTOGRAPHY";
    case FlightMode.FLIGHT_MODE_INTELLIGENT_TRACKING:
      return "FLIGHT_MODE_INTELLIGENT_TRACKING";
    case FlightMode.FLIGHT_MODE_ADS_B_AVOIDANCE:
      return "FLIGHT_MODE_ADS_B_AVOIDANCE";
    case FlightMode.FLIGHT_MODE_AUTO_RETURNING_TO_HOME:
      return "FLIGHT_MODE_AUTO_RETURNING_TO_HOME";
    case FlightMode.FLIGHT_MODE_AUTOMATIC_LANDING:
      return "FLIGHT_MODE_AUTOMATIC_LANDING";
    case FlightMode.FLIGHT_MODE_FORCED_LANDING:
      return "FLIGHT_MODE_FORCED_LANDING";
    case FlightMode.FLIGHT_MODE_THREE_BLADE_LANDING:
      return "FLIGHT_MODE_THREE_BLADE_LANDING";
    case FlightMode.FLIGHT_MODE_UPGRADING:
      return "FLIGHT_MODE_UPGRADING";
    case FlightMode.FLIGHT_MODE_NOT_CONNECTED:
      return "FLIGHT_MODE_NOT_CONNECTED";
    case FlightMode.FLIGHT_MODE_APAS:
      return "FLIGHT_MODE_APAS";
    case FlightMode.FLIGHT_MODE_VIRTUAL_STICK_STATE:
      return "FLIGHT_MODE_VIRTUAL_STICK_STATE";
    case FlightMode.FLIGHT_MODE_LIVE_FLIGHT_CONTROLS:
      return "FLIGHT_MODE_LIVE_FLIGHT_CONTROLS";
    case FlightMode.FLIGHT_MODE_AIRBORNE_RTK_FIXING_MODE:
      return "FLIGHT_MODE_AIRBORNE_RTK_FIXING_MODE";
    case FlightMode.FLIGHT_MODE_DOCK_ADDRESS_SELECTING:
      return "FLIGHT_MODE_DOCK_ADDRESS_SELECTING";
    case FlightMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Flight mode reason: 0–23 */
export enum FlightModeReason {
  FLIGHT_MODE_REASON_NO_MEANING = 0,
  FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_POWER = 1,
  FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_VOLTAGE = 2,
  FLIGHT_MODE_REASON_SEVERELY_LOW_VOLTAGE = 3,
  FLIGHT_MODE_REASON_REMOTE_CONTROLLER_BUTTONS = 4,
  FLIGHT_MODE_REASON_APP_REQUEST = 5,
  FLIGHT_MODE_REASON_LOSS_OF_REMOTE_CONTROLLER_SIGNAL = 6,
  FLIGHT_MODE_REASON_EXTERNAL_DEVICES = 7,
  FLIGHT_MODE_REASON_DOCK_GEO_ZONE = 8,
  FLIGHT_MODE_REASON_TOO_CLOSE_TO_HOME_POINT = 9,
  FLIGHT_MODE_REASON_TOO_FAR_FROM_HOME_POINT = 10,
  FLIGHT_MODE_REASON_WAYPOINT_MISSIONS = 11,
  FLIGHT_MODE_REASON_REACHED_ABOVE_HOME_POINT = 12,
  FLIGHT_MODE_REASON_SECOND_STAGE_DESCENT_LIMIT = 13,
  FLIGHT_MODE_REASON_LOW_ALTITUDE_PROTECTION_BREAKTHROUGH = 14,
  FLIGHT_MODE_REASON_PASSING_FLIGHTS_VICINITY = 15,
  FLIGHT_MODE_REASON_HEIGHT_CONTROL_FAILURE = 16,
  FLIGHT_MODE_REASON_INTELLIGENT_LOW_BATTERY_RETURN = 17,
  FLIGHT_MODE_REASON_AP_CONTROLS_FLIGHT_MODE = 18,
  FLIGHT_MODE_REASON_HARDWARE_ABNORMAL = 19,
  FLIGHT_MODE_REASON_END_OF_ANTI_COLLISION_PROTECTION = 20,
  FLIGHT_MODE_REASON_RETURN_CANCELED = 21,
  FLIGHT_MODE_REASON_OBSTACLES_DURING_RETURN = 22,
  FLIGHT_MODE_REASON_STRONG_WINDS_DOCK_SCENE = 23,
  UNRECOGNIZED = -1,
}

export function flightModeReasonFromJSON(object: any): FlightModeReason {
  switch (object) {
    case 0:
    case "FLIGHT_MODE_REASON_NO_MEANING":
      return FlightModeReason.FLIGHT_MODE_REASON_NO_MEANING;
    case 1:
    case "FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_POWER":
      return FlightModeReason.FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_POWER;
    case 2:
    case "FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_VOLTAGE":
      return FlightModeReason.FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_VOLTAGE;
    case 3:
    case "FLIGHT_MODE_REASON_SEVERELY_LOW_VOLTAGE":
      return FlightModeReason.FLIGHT_MODE_REASON_SEVERELY_LOW_VOLTAGE;
    case 4:
    case "FLIGHT_MODE_REASON_REMOTE_CONTROLLER_BUTTONS":
      return FlightModeReason.FLIGHT_MODE_REASON_REMOTE_CONTROLLER_BUTTONS;
    case 5:
    case "FLIGHT_MODE_REASON_APP_REQUEST":
      return FlightModeReason.FLIGHT_MODE_REASON_APP_REQUEST;
    case 6:
    case "FLIGHT_MODE_REASON_LOSS_OF_REMOTE_CONTROLLER_SIGNAL":
      return FlightModeReason.FLIGHT_MODE_REASON_LOSS_OF_REMOTE_CONTROLLER_SIGNAL;
    case 7:
    case "FLIGHT_MODE_REASON_EXTERNAL_DEVICES":
      return FlightModeReason.FLIGHT_MODE_REASON_EXTERNAL_DEVICES;
    case 8:
    case "FLIGHT_MODE_REASON_DOCK_GEO_ZONE":
      return FlightModeReason.FLIGHT_MODE_REASON_DOCK_GEO_ZONE;
    case 9:
    case "FLIGHT_MODE_REASON_TOO_CLOSE_TO_HOME_POINT":
      return FlightModeReason.FLIGHT_MODE_REASON_TOO_CLOSE_TO_HOME_POINT;
    case 10:
    case "FLIGHT_MODE_REASON_TOO_FAR_FROM_HOME_POINT":
      return FlightModeReason.FLIGHT_MODE_REASON_TOO_FAR_FROM_HOME_POINT;
    case 11:
    case "FLIGHT_MODE_REASON_WAYPOINT_MISSIONS":
      return FlightModeReason.FLIGHT_MODE_REASON_WAYPOINT_MISSIONS;
    case 12:
    case "FLIGHT_MODE_REASON_REACHED_ABOVE_HOME_POINT":
      return FlightModeReason.FLIGHT_MODE_REASON_REACHED_ABOVE_HOME_POINT;
    case 13:
    case "FLIGHT_MODE_REASON_SECOND_STAGE_DESCENT_LIMIT":
      return FlightModeReason.FLIGHT_MODE_REASON_SECOND_STAGE_DESCENT_LIMIT;
    case 14:
    case "FLIGHT_MODE_REASON_LOW_ALTITUDE_PROTECTION_BREAKTHROUGH":
      return FlightModeReason.FLIGHT_MODE_REASON_LOW_ALTITUDE_PROTECTION_BREAKTHROUGH;
    case 15:
    case "FLIGHT_MODE_REASON_PASSING_FLIGHTS_VICINITY":
      return FlightModeReason.FLIGHT_MODE_REASON_PASSING_FLIGHTS_VICINITY;
    case 16:
    case "FLIGHT_MODE_REASON_HEIGHT_CONTROL_FAILURE":
      return FlightModeReason.FLIGHT_MODE_REASON_HEIGHT_CONTROL_FAILURE;
    case 17:
    case "FLIGHT_MODE_REASON_INTELLIGENT_LOW_BATTERY_RETURN":
      return FlightModeReason.FLIGHT_MODE_REASON_INTELLIGENT_LOW_BATTERY_RETURN;
    case 18:
    case "FLIGHT_MODE_REASON_AP_CONTROLS_FLIGHT_MODE":
      return FlightModeReason.FLIGHT_MODE_REASON_AP_CONTROLS_FLIGHT_MODE;
    case 19:
    case "FLIGHT_MODE_REASON_HARDWARE_ABNORMAL":
      return FlightModeReason.FLIGHT_MODE_REASON_HARDWARE_ABNORMAL;
    case 20:
    case "FLIGHT_MODE_REASON_END_OF_ANTI_COLLISION_PROTECTION":
      return FlightModeReason.FLIGHT_MODE_REASON_END_OF_ANTI_COLLISION_PROTECTION;
    case 21:
    case "FLIGHT_MODE_REASON_RETURN_CANCELED":
      return FlightModeReason.FLIGHT_MODE_REASON_RETURN_CANCELED;
    case 22:
    case "FLIGHT_MODE_REASON_OBSTACLES_DURING_RETURN":
      return FlightModeReason.FLIGHT_MODE_REASON_OBSTACLES_DURING_RETURN;
    case 23:
    case "FLIGHT_MODE_REASON_STRONG_WINDS_DOCK_SCENE":
      return FlightModeReason.FLIGHT_MODE_REASON_STRONG_WINDS_DOCK_SCENE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FlightModeReason.UNRECOGNIZED;
  }
}

export function flightModeReasonToJSON(object: FlightModeReason): string {
  switch (object) {
    case FlightModeReason.FLIGHT_MODE_REASON_NO_MEANING:
      return "FLIGHT_MODE_REASON_NO_MEANING";
    case FlightModeReason.FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_POWER:
      return "FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_POWER";
    case FlightModeReason.FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_VOLTAGE:
      return "FLIGHT_MODE_REASON_INSUFFICIENT_BATTERY_VOLTAGE";
    case FlightModeReason.FLIGHT_MODE_REASON_SEVERELY_LOW_VOLTAGE:
      return "FLIGHT_MODE_REASON_SEVERELY_LOW_VOLTAGE";
    case FlightModeReason.FLIGHT_MODE_REASON_REMOTE_CONTROLLER_BUTTONS:
      return "FLIGHT_MODE_REASON_REMOTE_CONTROLLER_BUTTONS";
    case FlightModeReason.FLIGHT_MODE_REASON_APP_REQUEST:
      return "FLIGHT_MODE_REASON_APP_REQUEST";
    case FlightModeReason.FLIGHT_MODE_REASON_LOSS_OF_REMOTE_CONTROLLER_SIGNAL:
      return "FLIGHT_MODE_REASON_LOSS_OF_REMOTE_CONTROLLER_SIGNAL";
    case FlightModeReason.FLIGHT_MODE_REASON_EXTERNAL_DEVICES:
      return "FLIGHT_MODE_REASON_EXTERNAL_DEVICES";
    case FlightModeReason.FLIGHT_MODE_REASON_DOCK_GEO_ZONE:
      return "FLIGHT_MODE_REASON_DOCK_GEO_ZONE";
    case FlightModeReason.FLIGHT_MODE_REASON_TOO_CLOSE_TO_HOME_POINT:
      return "FLIGHT_MODE_REASON_TOO_CLOSE_TO_HOME_POINT";
    case FlightModeReason.FLIGHT_MODE_REASON_TOO_FAR_FROM_HOME_POINT:
      return "FLIGHT_MODE_REASON_TOO_FAR_FROM_HOME_POINT";
    case FlightModeReason.FLIGHT_MODE_REASON_WAYPOINT_MISSIONS:
      return "FLIGHT_MODE_REASON_WAYPOINT_MISSIONS";
    case FlightModeReason.FLIGHT_MODE_REASON_REACHED_ABOVE_HOME_POINT:
      return "FLIGHT_MODE_REASON_REACHED_ABOVE_HOME_POINT";
    case FlightModeReason.FLIGHT_MODE_REASON_SECOND_STAGE_DESCENT_LIMIT:
      return "FLIGHT_MODE_REASON_SECOND_STAGE_DESCENT_LIMIT";
    case FlightModeReason.FLIGHT_MODE_REASON_LOW_ALTITUDE_PROTECTION_BREAKTHROUGH:
      return "FLIGHT_MODE_REASON_LOW_ALTITUDE_PROTECTION_BREAKTHROUGH";
    case FlightModeReason.FLIGHT_MODE_REASON_PASSING_FLIGHTS_VICINITY:
      return "FLIGHT_MODE_REASON_PASSING_FLIGHTS_VICINITY";
    case FlightModeReason.FLIGHT_MODE_REASON_HEIGHT_CONTROL_FAILURE:
      return "FLIGHT_MODE_REASON_HEIGHT_CONTROL_FAILURE";
    case FlightModeReason.FLIGHT_MODE_REASON_INTELLIGENT_LOW_BATTERY_RETURN:
      return "FLIGHT_MODE_REASON_INTELLIGENT_LOW_BATTERY_RETURN";
    case FlightModeReason.FLIGHT_MODE_REASON_AP_CONTROLS_FLIGHT_MODE:
      return "FLIGHT_MODE_REASON_AP_CONTROLS_FLIGHT_MODE";
    case FlightModeReason.FLIGHT_MODE_REASON_HARDWARE_ABNORMAL:
      return "FLIGHT_MODE_REASON_HARDWARE_ABNORMAL";
    case FlightModeReason.FLIGHT_MODE_REASON_END_OF_ANTI_COLLISION_PROTECTION:
      return "FLIGHT_MODE_REASON_END_OF_ANTI_COLLISION_PROTECTION";
    case FlightModeReason.FLIGHT_MODE_REASON_RETURN_CANCELED:
      return "FLIGHT_MODE_REASON_RETURN_CANCELED";
    case FlightModeReason.FLIGHT_MODE_REASON_OBSTACLES_DURING_RETURN:
      return "FLIGHT_MODE_REASON_OBSTACLES_DURING_RETURN";
    case FlightModeReason.FLIGHT_MODE_REASON_STRONG_WINDS_DOCK_SCENE:
      return "FLIGHT_MODE_REASON_STRONG_WINDS_DOCK_SCENE";
    case FlightModeReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Strategy when the commander/mission loses RC control */
export enum RcLostStrategy {
  RC_LOST_STRATEGY_CONTINUE_TASK = 0,
  RC_LOST_STRATEGY_EXIT_AND_EXECUTE = 1,
  UNRECOGNIZED = -1,
}

export function rcLostStrategyFromJSON(object: any): RcLostStrategy {
  switch (object) {
    case 0:
    case "RC_LOST_STRATEGY_CONTINUE_TASK":
      return RcLostStrategy.RC_LOST_STRATEGY_CONTINUE_TASK;
    case 1:
    case "RC_LOST_STRATEGY_EXIT_AND_EXECUTE":
      return RcLostStrategy.RC_LOST_STRATEGY_EXIT_AND_EXECUTE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RcLostStrategy.UNRECOGNIZED;
  }
}

export function rcLostStrategyToJSON(object: RcLostStrategy): string {
  switch (object) {
    case RcLostStrategy.RC_LOST_STRATEGY_CONTINUE_TASK:
      return "RC_LOST_STRATEGY_CONTINUE_TASK";
    case RcLostStrategy.RC_LOST_STRATEGY_EXIT_AND_EXECUTE:
      return "RC_LOST_STRATEGY_EXIT_AND_EXECUTE";
    case RcLostStrategy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Approaching GEO Zone state */
export enum NearAreaLimitState {
  /** NEAR_AREA_LIMIT_NOT_REACHED - Not reaching the GEO Zone */
  NEAR_AREA_LIMIT_NOT_REACHED = 0,
  /** NEAR_AREA_LIMIT_APPROACHING - Approaching the GEO Zone */
  NEAR_AREA_LIMIT_APPROACHING = 1,
  UNRECOGNIZED = -1,
}

export function nearAreaLimitStateFromJSON(object: any): NearAreaLimitState {
  switch (object) {
    case 0:
    case "NEAR_AREA_LIMIT_NOT_REACHED":
      return NearAreaLimitState.NEAR_AREA_LIMIT_NOT_REACHED;
    case 1:
    case "NEAR_AREA_LIMIT_APPROACHING":
      return NearAreaLimitState.NEAR_AREA_LIMIT_APPROACHING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NearAreaLimitState.UNRECOGNIZED;
  }
}

export function nearAreaLimitStateToJSON(object: NearAreaLimitState): string {
  switch (object) {
    case NearAreaLimitState.NEAR_AREA_LIMIT_NOT_REACHED:
      return "NEAR_AREA_LIMIT_NOT_REACHED";
    case NearAreaLimitState.NEAR_AREA_LIMIT_APPROACHING:
      return "NEAR_AREA_LIMIT_APPROACHING";
    case NearAreaLimitState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Approaching Height Limit state */
export enum NearHeightLimitState {
  /** NEAR_HEIGHT_LIMIT_NOT_REACHED - Not reaching the set height limit */
  NEAR_HEIGHT_LIMIT_NOT_REACHED = 0,
  /** NEAR_HEIGHT_LIMIT_APPROACHING - Approaching the set height limit */
  NEAR_HEIGHT_LIMIT_APPROACHING = 1,
  UNRECOGNIZED = -1,
}

export function nearHeightLimitStateFromJSON(object: any): NearHeightLimitState {
  switch (object) {
    case 0:
    case "NEAR_HEIGHT_LIMIT_NOT_REACHED":
      return NearHeightLimitState.NEAR_HEIGHT_LIMIT_NOT_REACHED;
    case 1:
    case "NEAR_HEIGHT_LIMIT_APPROACHING":
      return NearHeightLimitState.NEAR_HEIGHT_LIMIT_APPROACHING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NearHeightLimitState.UNRECOGNIZED;
  }
}

export function nearHeightLimitStateToJSON(object: NearHeightLimitState): string {
  switch (object) {
    case NearHeightLimitState.NEAR_HEIGHT_LIMIT_NOT_REACHED:
      return "NEAR_HEIGHT_LIMIT_NOT_REACHED";
    case NearHeightLimitState.NEAR_HEIGHT_LIMIT_APPROACHING:
      return "NEAR_HEIGHT_LIMIT_APPROACHING";
    case NearHeightLimitState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface DroneOSD {
  /** Main OSD data structure - from DroneOsd.msg */
  timestamp:
    | Date
    | undefined;
  /** Drone ROS: DroneOsd.msg -> country */
  country: string;
  /** Drone ROS: DroneOsd.msg -> tid */
  tid: string;
  /** Drone ROS: DroneOsd.msg -> bid */
  bid: string;
  /** Drone ROS: DroneOsd.msg -> gateway */
  gateway: string;
  /** Drone ROS: DroneOsd.msg -> mode_code */
  modeCode: FlightMode;
  /** Drone ROS: DroneOsd.msg -> mode_code_reason */
  modeCodeReason: FlightModeReason;
  /** Drone ROS: DroneOsd.msg -> distance_limit_status */
  distanceLimitStatus:
    | DroneOSD_DistanceLimitStatus
    | undefined;
  /** Drone ROS: DroneOsd.msg -> rth_altitude */
  rthAltitude: number;
  /** Drone ROS: DroneOsd.msg -> rc_lost_action */
  rcLostStrategy: RcLostStrategy;
  /** Drone ROS: DroneOsd.msg -> exit_wayline_when_rc_lost */
  exitWaylineWhenRcLost: number;
  /** Drone ROS: DroneOsd.msg -> cameras[] // It is not abstracted as common since it is drone specific Payload */
  cameras: DroneOSD_DroneCamera[];
  /** Drone ROS: DroneOsd.msg -> horizontal_speed */
  horizontalSpeed: number;
  /** Drone ROS: DroneOsd.msg -> vertical_speed */
  verticalSpeed: number;
  /** Drone ROS: DroneOsd.msg -> longitude */
  longitude: number;
  /** Drone ROS: DroneOsd.msg -> latitude */
  latitude: number;
  /** Drone ROS: DroneOsd.msg -> height */
  height: number;
  /** Drone ROS: DroneOsd.msg -> elevation */
  elevation: number;
  /** Drone ROS: DroneOsd.msg -> attitude_pitch */
  attitudePitch: number;
  /** Drone ROS: DroneOsd.msg -> attitude_roll */
  attitudeRoll: number;
  /** Drone ROS: DroneOsd.msg -> attitude_head */
  attitudeHead: number;
  /** Drone ROS: DroneOsd.msg -> home_distance */
  homeDistance: number;
  /** Drone ROS: DroneOsd.msg -> home_latitude */
  homeLatitude: number;
  /** Drone ROS: DroneOsd.msg -> home_longitude */
  homeLongitude: number;
  /** Drone ROS: DroneOsd.msg -> wind_speed */
  windSpeed: number;
  /** Drone ROS: DroneOsd.msg -> wind_direction */
  windDirection: number;
  /** Drone ROS: DroneOsd.msg -> gear */
  gear: number;
  /** Drone ROS: DroneOsd.msg -> total_flight_time */
  totalFlightTime:
    | Duration
    | undefined;
  /** Drone ROS: DroneOsd.msg -> total_flight_distance */
  totalFlightDistance: number;
  /** Drone ROS: DroneOsd.msg -> storage */
  storage:
    | Storage
    | undefined;
  /** Drone ROS: DroneOsd.msg -> position_state */
  positionState:
    | DroneOSD_PositionState
    | undefined;
  /** Drone ROS: DroneOsd.msg -> total_flight_sorties */
  totalFlightSorties: number;
  /** Drone ROS: DroneOsd.msg -> maintain_status */
  maintainStatus:
    | DroneOSD_MaintainStatus
    | undefined;
  /** Drone ROS: DroneOsd.msg -> night_lights_state */
  nightLightsState: number;
  /** Drone ROS: DroneOsd.msg -> height_limit */
  heightLimit: number;
  /** Drone ROS: DroneOsd.msg -> obstacle_avoidance */
  obstacleAvoidance:
    | DroneOSD_ObstacleAvoidance
    | undefined;
  /** Drone ROS: DroneOsd.msg -> gimbal_index */
  gimbalIndex:
    | DroneOSD_GimbalIndex
    | undefined;
  /** Drone ROS: DroneOsd.msg -> rid_state */
  ridState: boolean;
  /** Drone ROS: DroneOsd.msg -> is_near_area_limit */
  isNearAreaLimit: NearAreaLimitState;
  /** Drone ROS: DroneOsd.msg -> is_near_height_limit */
  isNearHeightLimit: NearHeightLimitState;
  /** Drone ROS: DroneOsd.msg -> activation_time */
  activationTime:
    | Date
    | undefined;
  /** Drone ROS: DroneOsd.msg -> video_type */
  videoType: string;
}

export interface DroneOSD_DroneCamera {
  /** Drone ROS: Camera.msg -> remain_photo_num */
  remainPhotoNum: number;
  /** Drone ROS: Camera.msg -> remain_record_duration */
  remainRecordDuration:
    | Duration
    | undefined;
  /** Drone ROS: Camera.msg -> record_time */
  recordTime:
    | Duration
    | undefined;
  /** Drone ROS: Camera.msg -> payload_index */
  payloadIndex: string;
  /** Drone ROS: Camera.msg -> camera_mode */
  cameraMode: CameraMode;
  /** Drone ROS: Camera.msg -> photo_state */
  photoState: PhotoState;
  /** Drone ROS: Camera.msg -> screen_split_enable */
  screenSplitEnable: boolean;
  /** Drone ROS: Camera.msg -> recording_state */
  recordingState: RecordingState;
  /** Drone ROS: Camera.msg -> zoom_factor */
  zoomFactor: number;
  /** Drone ROS: Camera.msg -> ir_zoom_factor */
  irZoomFactor: number;
  /** Drone ROS: Camera.msg -> liveview_world_region */
  liveviewWorldRegion:
    | DroneOSD_LiveviewWorldRegion
    | undefined;
  /** Drone ROS: Camera.msg -> photo_storage_settings[] */
  photoStorageSettings: string[];
  /** Drone ROS: Camera.msg -> video_storage_settings[] */
  videoStorageSettings: string[];
}

/** Field of view (FOV) region in liveview */
export interface DroneOSD_LiveviewWorldRegion {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

/** Aircraft distance limit state */
export interface DroneOSD_DistanceLimitStatus {
  /** Whether to enable the limit distance */
  state: boolean;
  /** Limited distance: {"max":"8000","min":"15","step":"1","unit_name":"Meters / m"} */
  distanceLimit: number;
  /** Whether approaching the set distance limit: [int32] {"0":"Not reaching the set distance limit","1":"Approaching the set distance limit"} */
  isNearDistanceLimit: boolean;
}

/** Satellite search state */
export interface DroneOSD_PositionState {
  /** Drone ROS: PositionState.msg -> is_fixed */
  isFixed: FixingState;
  /** Drone ROS: PositionState.msg -> quality */
  quality: PositionQuality;
  /** Drone ROS: PositionState.msg -> gps_number // Number of GPS satellites */
  gpsNumber: number;
  /** Drone ROS: PositionState.msg -> rtk_number // Number of RTK satellite acquisitions */
  rtkNumber: number;
}

export interface DroneOSD_MaintainStatus {
  maintainStatusArray: DroneOSD_MaintainStatusStruct[];
}

export interface DroneOSD_MaintainStatusStruct {
  /** Drone ROS: {"0":"No maintenance","1":"With maintenance"} */
  state: number;
  /** Drone ROS: MaintainStatusStruct.msg -> last_maintain_type : {"1":"Basic maintenance of the aircraft","2":"Regular maintenance of the aircraft","3":"Deep maintenance of the aircraft"} */
  lastMaintainType: number;
  /** Drone ROS: MaintainStatusStruct.msg -> last_maintain_time */
  lastMaintainTime:
    | Date
    | undefined;
  /** Drone ROS: MaintainStatusStruct.msg -> last_maintain_flight_time  [hours] */
  lastMaintainFlightTime: number;
  /** Drone ROS: MaintainStatusStruct.msg -> last_maintain_flight_sorties {"max":"2147483647","min":"0","step":"1"} */
  lastMaintainFlightSorties: number;
}

export interface DroneOSD_ObstacleAvoidance {
  /** Drone ROS: ObstacleAvoidance.msg -> horizon */
  horizon: boolean;
  /** Drone ROS: ObstacleAvoidance.msg -> upside */
  upside: boolean;
  /** Drone ROS: ObstacleAvoidance.msg -> downside */
  downside: boolean;
}

export interface DroneOSD_GimbalIndex {
  gimbalPitch: number;
  gimbalRoll: number;
  gimbalYaw: number;
  measureTargetLongitude: number;
  measureTargetLatitude: number;
  measureTargetDistance: number;
  measureTargetErrorState: number;
  payloadIndex: string;
  zoomFactor: number;
  thermalCurrentPaletteStyle: number;
  thermalSupportedPaletteStyles: number[];
  thermalGainMode: number;
  thermalIsothermState: number;
  thermalIsothermUpperLimit: number;
  thermalIsothermLowerLimit: number;
  thermalGlobalTemperatureMin: number;
  thermalGlobalTemperatureMax: number;
}

function createBaseDroneOSD(): DroneOSD {
  return {
    timestamp: undefined,
    country: "",
    tid: "",
    bid: "",
    gateway: "",
    modeCode: 0,
    modeCodeReason: 0,
    distanceLimitStatus: undefined,
    rthAltitude: 0,
    rcLostStrategy: 0,
    exitWaylineWhenRcLost: 0,
    cameras: [],
    horizontalSpeed: 0,
    verticalSpeed: 0,
    longitude: 0,
    latitude: 0,
    height: 0,
    elevation: 0,
    attitudePitch: 0,
    attitudeRoll: 0,
    attitudeHead: 0,
    homeDistance: 0,
    homeLatitude: 0,
    homeLongitude: 0,
    windSpeed: 0,
    windDirection: 0,
    gear: 0,
    totalFlightTime: undefined,
    totalFlightDistance: 0,
    storage: undefined,
    positionState: undefined,
    totalFlightSorties: 0,
    maintainStatus: undefined,
    nightLightsState: 0,
    heightLimit: 0,
    obstacleAvoidance: undefined,
    gimbalIndex: undefined,
    ridState: false,
    isNearAreaLimit: 0,
    isNearHeightLimit: 0,
    activationTime: undefined,
    videoType: "",
  };
}

export const DroneOSD: MessageFns<DroneOSD> = {
  encode(message: DroneOSD, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(10).fork()).join();
    }
    if (message.country !== "") {
      writer.uint32(18).string(message.country);
    }
    if (message.tid !== "") {
      writer.uint32(26).string(message.tid);
    }
    if (message.bid !== "") {
      writer.uint32(34).string(message.bid);
    }
    if (message.gateway !== "") {
      writer.uint32(42).string(message.gateway);
    }
    if (message.modeCode !== 0) {
      writer.uint32(48).int32(message.modeCode);
    }
    if (message.modeCodeReason !== 0) {
      writer.uint32(56).int32(message.modeCodeReason);
    }
    if (message.distanceLimitStatus !== undefined) {
      DroneOSD_DistanceLimitStatus.encode(message.distanceLimitStatus, writer.uint32(66).fork()).join();
    }
    if (message.rthAltitude !== 0) {
      writer.uint32(73).double(message.rthAltitude);
    }
    if (message.rcLostStrategy !== 0) {
      writer.uint32(80).int32(message.rcLostStrategy);
    }
    if (message.exitWaylineWhenRcLost !== 0) {
      writer.uint32(88).int32(message.exitWaylineWhenRcLost);
    }
    for (const v of message.cameras) {
      DroneOSD_DroneCamera.encode(v!, writer.uint32(98).fork()).join();
    }
    if (message.horizontalSpeed !== 0) {
      writer.uint32(105).double(message.horizontalSpeed);
    }
    if (message.verticalSpeed !== 0) {
      writer.uint32(113).double(message.verticalSpeed);
    }
    if (message.longitude !== 0) {
      writer.uint32(121).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(129).double(message.latitude);
    }
    if (message.height !== 0) {
      writer.uint32(137).double(message.height);
    }
    if (message.elevation !== 0) {
      writer.uint32(145).double(message.elevation);
    }
    if (message.attitudePitch !== 0) {
      writer.uint32(153).double(message.attitudePitch);
    }
    if (message.attitudeRoll !== 0) {
      writer.uint32(161).double(message.attitudeRoll);
    }
    if (message.attitudeHead !== 0) {
      writer.uint32(169).double(message.attitudeHead);
    }
    if (message.homeDistance !== 0) {
      writer.uint32(177).double(message.homeDistance);
    }
    if (message.homeLatitude !== 0) {
      writer.uint32(185).double(message.homeLatitude);
    }
    if (message.homeLongitude !== 0) {
      writer.uint32(193).double(message.homeLongitude);
    }
    if (message.windSpeed !== 0) {
      writer.uint32(201).double(message.windSpeed);
    }
    if (message.windDirection !== 0) {
      writer.uint32(208).int32(message.windDirection);
    }
    if (message.gear !== 0) {
      writer.uint32(216).int32(message.gear);
    }
    if (message.totalFlightTime !== undefined) {
      Duration.encode(message.totalFlightTime, writer.uint32(226).fork()).join();
    }
    if (message.totalFlightDistance !== 0) {
      writer.uint32(233).double(message.totalFlightDistance);
    }
    if (message.storage !== undefined) {
      Storage.encode(message.storage, writer.uint32(242).fork()).join();
    }
    if (message.positionState !== undefined) {
      DroneOSD_PositionState.encode(message.positionState, writer.uint32(250).fork()).join();
    }
    if (message.totalFlightSorties !== 0) {
      writer.uint32(256).int32(message.totalFlightSorties);
    }
    if (message.maintainStatus !== undefined) {
      DroneOSD_MaintainStatus.encode(message.maintainStatus, writer.uint32(266).fork()).join();
    }
    if (message.nightLightsState !== 0) {
      writer.uint32(272).int32(message.nightLightsState);
    }
    if (message.heightLimit !== 0) {
      writer.uint32(280).int32(message.heightLimit);
    }
    if (message.obstacleAvoidance !== undefined) {
      DroneOSD_ObstacleAvoidance.encode(message.obstacleAvoidance, writer.uint32(290).fork()).join();
    }
    if (message.gimbalIndex !== undefined) {
      DroneOSD_GimbalIndex.encode(message.gimbalIndex, writer.uint32(298).fork()).join();
    }
    if (message.ridState !== false) {
      writer.uint32(304).bool(message.ridState);
    }
    if (message.isNearAreaLimit !== 0) {
      writer.uint32(312).int32(message.isNearAreaLimit);
    }
    if (message.isNearHeightLimit !== 0) {
      writer.uint32(320).int32(message.isNearHeightLimit);
    }
    if (message.activationTime !== undefined) {
      Timestamp.encode(toTimestamp(message.activationTime), writer.uint32(330).fork()).join();
    }
    if (message.videoType !== "") {
      writer.uint32(338).string(message.videoType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.country = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.bid = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.gateway = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.modeCode = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.modeCodeReason = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.distanceLimitStatus = DroneOSD_DistanceLimitStatus.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.rthAltitude = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.rcLostStrategy = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.exitWaylineWhenRcLost = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.cameras.push(DroneOSD_DroneCamera.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 105) {
            break;
          }

          message.horizontalSpeed = reader.double();
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.verticalSpeed = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 129) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.height = reader.double();
          continue;
        }
        case 18: {
          if (tag !== 145) {
            break;
          }

          message.elevation = reader.double();
          continue;
        }
        case 19: {
          if (tag !== 153) {
            break;
          }

          message.attitudePitch = reader.double();
          continue;
        }
        case 20: {
          if (tag !== 161) {
            break;
          }

          message.attitudeRoll = reader.double();
          continue;
        }
        case 21: {
          if (tag !== 169) {
            break;
          }

          message.attitudeHead = reader.double();
          continue;
        }
        case 22: {
          if (tag !== 177) {
            break;
          }

          message.homeDistance = reader.double();
          continue;
        }
        case 23: {
          if (tag !== 185) {
            break;
          }

          message.homeLatitude = reader.double();
          continue;
        }
        case 24: {
          if (tag !== 193) {
            break;
          }

          message.homeLongitude = reader.double();
          continue;
        }
        case 25: {
          if (tag !== 201) {
            break;
          }

          message.windSpeed = reader.double();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.windDirection = reader.int32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.gear = reader.int32();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.totalFlightTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 29: {
          if (tag !== 233) {
            break;
          }

          message.totalFlightDistance = reader.double();
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.storage = Storage.decode(reader, reader.uint32());
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.positionState = DroneOSD_PositionState.decode(reader, reader.uint32());
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.totalFlightSorties = reader.int32();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.maintainStatus = DroneOSD_MaintainStatus.decode(reader, reader.uint32());
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.nightLightsState = reader.int32();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.heightLimit = reader.int32();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.obstacleAvoidance = DroneOSD_ObstacleAvoidance.decode(reader, reader.uint32());
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.gimbalIndex = DroneOSD_GimbalIndex.decode(reader, reader.uint32());
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.ridState = reader.bool();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.isNearAreaLimit = reader.int32() as any;
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.isNearHeightLimit = reader.int32() as any;
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.activationTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.videoType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD {
    return {
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      country: isSet(object.country) ? globalThis.String(object.country) : "",
      tid: isSet(object.tid) ? globalThis.String(object.tid) : "",
      bid: isSet(object.bid) ? globalThis.String(object.bid) : "",
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
      modeCode: isSet(object.modeCode) ? flightModeFromJSON(object.modeCode) : 0,
      modeCodeReason: isSet(object.modeCodeReason) ? flightModeReasonFromJSON(object.modeCodeReason) : 0,
      distanceLimitStatus: isSet(object.distanceLimitStatus)
        ? DroneOSD_DistanceLimitStatus.fromJSON(object.distanceLimitStatus)
        : undefined,
      rthAltitude: isSet(object.rthAltitude) ? globalThis.Number(object.rthAltitude) : 0,
      rcLostStrategy: isSet(object.rcLostStrategy) ? rcLostStrategyFromJSON(object.rcLostStrategy) : 0,
      exitWaylineWhenRcLost: isSet(object.exitWaylineWhenRcLost) ? globalThis.Number(object.exitWaylineWhenRcLost) : 0,
      cameras: globalThis.Array.isArray(object?.cameras)
        ? object.cameras.map((e: any) => DroneOSD_DroneCamera.fromJSON(e))
        : [],
      horizontalSpeed: isSet(object.horizontalSpeed) ? globalThis.Number(object.horizontalSpeed) : 0,
      verticalSpeed: isSet(object.verticalSpeed) ? globalThis.Number(object.verticalSpeed) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      elevation: isSet(object.elevation) ? globalThis.Number(object.elevation) : 0,
      attitudePitch: isSet(object.attitudePitch) ? globalThis.Number(object.attitudePitch) : 0,
      attitudeRoll: isSet(object.attitudeRoll) ? globalThis.Number(object.attitudeRoll) : 0,
      attitudeHead: isSet(object.attitudeHead) ? globalThis.Number(object.attitudeHead) : 0,
      homeDistance: isSet(object.homeDistance) ? globalThis.Number(object.homeDistance) : 0,
      homeLatitude: isSet(object.homeLatitude) ? globalThis.Number(object.homeLatitude) : 0,
      homeLongitude: isSet(object.homeLongitude) ? globalThis.Number(object.homeLongitude) : 0,
      windSpeed: isSet(object.windSpeed) ? globalThis.Number(object.windSpeed) : 0,
      windDirection: isSet(object.windDirection) ? globalThis.Number(object.windDirection) : 0,
      gear: isSet(object.gear) ? globalThis.Number(object.gear) : 0,
      totalFlightTime: isSet(object.totalFlightTime) ? Duration.fromJSON(object.totalFlightTime) : undefined,
      totalFlightDistance: isSet(object.totalFlightDistance) ? globalThis.Number(object.totalFlightDistance) : 0,
      storage: isSet(object.storage) ? Storage.fromJSON(object.storage) : undefined,
      positionState: isSet(object.positionState) ? DroneOSD_PositionState.fromJSON(object.positionState) : undefined,
      totalFlightSorties: isSet(object.totalFlightSorties) ? globalThis.Number(object.totalFlightSorties) : 0,
      maintainStatus: isSet(object.maintainStatus)
        ? DroneOSD_MaintainStatus.fromJSON(object.maintainStatus)
        : undefined,
      nightLightsState: isSet(object.nightLightsState) ? globalThis.Number(object.nightLightsState) : 0,
      heightLimit: isSet(object.heightLimit) ? globalThis.Number(object.heightLimit) : 0,
      obstacleAvoidance: isSet(object.obstacleAvoidance)
        ? DroneOSD_ObstacleAvoidance.fromJSON(object.obstacleAvoidance)
        : undefined,
      gimbalIndex: isSet(object.gimbalIndex) ? DroneOSD_GimbalIndex.fromJSON(object.gimbalIndex) : undefined,
      ridState: isSet(object.ridState) ? globalThis.Boolean(object.ridState) : false,
      isNearAreaLimit: isSet(object.isNearAreaLimit) ? nearAreaLimitStateFromJSON(object.isNearAreaLimit) : 0,
      isNearHeightLimit: isSet(object.isNearHeightLimit) ? nearHeightLimitStateFromJSON(object.isNearHeightLimit) : 0,
      activationTime: isSet(object.activationTime) ? fromJsonTimestamp(object.activationTime) : undefined,
      videoType: isSet(object.videoType) ? globalThis.String(object.videoType) : "",
    };
  },

  toJSON(message: DroneOSD): unknown {
    const obj: any = {};
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    if (message.tid !== "") {
      obj.tid = message.tid;
    }
    if (message.bid !== "") {
      obj.bid = message.bid;
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    if (message.modeCode !== 0) {
      obj.modeCode = flightModeToJSON(message.modeCode);
    }
    if (message.modeCodeReason !== 0) {
      obj.modeCodeReason = flightModeReasonToJSON(message.modeCodeReason);
    }
    if (message.distanceLimitStatus !== undefined) {
      obj.distanceLimitStatus = DroneOSD_DistanceLimitStatus.toJSON(message.distanceLimitStatus);
    }
    if (message.rthAltitude !== 0) {
      obj.rthAltitude = message.rthAltitude;
    }
    if (message.rcLostStrategy !== 0) {
      obj.rcLostStrategy = rcLostStrategyToJSON(message.rcLostStrategy);
    }
    if (message.exitWaylineWhenRcLost !== 0) {
      obj.exitWaylineWhenRcLost = Math.round(message.exitWaylineWhenRcLost);
    }
    if (message.cameras?.length) {
      obj.cameras = message.cameras.map((e) => DroneOSD_DroneCamera.toJSON(e));
    }
    if (message.horizontalSpeed !== 0) {
      obj.horizontalSpeed = message.horizontalSpeed;
    }
    if (message.verticalSpeed !== 0) {
      obj.verticalSpeed = message.verticalSpeed;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.elevation !== 0) {
      obj.elevation = message.elevation;
    }
    if (message.attitudePitch !== 0) {
      obj.attitudePitch = message.attitudePitch;
    }
    if (message.attitudeRoll !== 0) {
      obj.attitudeRoll = message.attitudeRoll;
    }
    if (message.attitudeHead !== 0) {
      obj.attitudeHead = message.attitudeHead;
    }
    if (message.homeDistance !== 0) {
      obj.homeDistance = message.homeDistance;
    }
    if (message.homeLatitude !== 0) {
      obj.homeLatitude = message.homeLatitude;
    }
    if (message.homeLongitude !== 0) {
      obj.homeLongitude = message.homeLongitude;
    }
    if (message.windSpeed !== 0) {
      obj.windSpeed = message.windSpeed;
    }
    if (message.windDirection !== 0) {
      obj.windDirection = Math.round(message.windDirection);
    }
    if (message.gear !== 0) {
      obj.gear = Math.round(message.gear);
    }
    if (message.totalFlightTime !== undefined) {
      obj.totalFlightTime = Duration.toJSON(message.totalFlightTime);
    }
    if (message.totalFlightDistance !== 0) {
      obj.totalFlightDistance = message.totalFlightDistance;
    }
    if (message.storage !== undefined) {
      obj.storage = Storage.toJSON(message.storage);
    }
    if (message.positionState !== undefined) {
      obj.positionState = DroneOSD_PositionState.toJSON(message.positionState);
    }
    if (message.totalFlightSorties !== 0) {
      obj.totalFlightSorties = Math.round(message.totalFlightSorties);
    }
    if (message.maintainStatus !== undefined) {
      obj.maintainStatus = DroneOSD_MaintainStatus.toJSON(message.maintainStatus);
    }
    if (message.nightLightsState !== 0) {
      obj.nightLightsState = Math.round(message.nightLightsState);
    }
    if (message.heightLimit !== 0) {
      obj.heightLimit = Math.round(message.heightLimit);
    }
    if (message.obstacleAvoidance !== undefined) {
      obj.obstacleAvoidance = DroneOSD_ObstacleAvoidance.toJSON(message.obstacleAvoidance);
    }
    if (message.gimbalIndex !== undefined) {
      obj.gimbalIndex = DroneOSD_GimbalIndex.toJSON(message.gimbalIndex);
    }
    if (message.ridState !== false) {
      obj.ridState = message.ridState;
    }
    if (message.isNearAreaLimit !== 0) {
      obj.isNearAreaLimit = nearAreaLimitStateToJSON(message.isNearAreaLimit);
    }
    if (message.isNearHeightLimit !== 0) {
      obj.isNearHeightLimit = nearHeightLimitStateToJSON(message.isNearHeightLimit);
    }
    if (message.activationTime !== undefined) {
      obj.activationTime = message.activationTime.toISOString();
    }
    if (message.videoType !== "") {
      obj.videoType = message.videoType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD>, I>>(base?: I): DroneOSD {
    return DroneOSD.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD>, I>>(object: I): DroneOSD {
    const message = createBaseDroneOSD();
    message.timestamp = object.timestamp ?? undefined;
    message.country = object.country ?? "";
    message.tid = object.tid ?? "";
    message.bid = object.bid ?? "";
    message.gateway = object.gateway ?? "";
    message.modeCode = object.modeCode ?? 0;
    message.modeCodeReason = object.modeCodeReason ?? 0;
    message.distanceLimitStatus = (object.distanceLimitStatus !== undefined && object.distanceLimitStatus !== null)
      ? DroneOSD_DistanceLimitStatus.fromPartial(object.distanceLimitStatus)
      : undefined;
    message.rthAltitude = object.rthAltitude ?? 0;
    message.rcLostStrategy = object.rcLostStrategy ?? 0;
    message.exitWaylineWhenRcLost = object.exitWaylineWhenRcLost ?? 0;
    message.cameras = object.cameras?.map((e) => DroneOSD_DroneCamera.fromPartial(e)) || [];
    message.horizontalSpeed = object.horizontalSpeed ?? 0;
    message.verticalSpeed = object.verticalSpeed ?? 0;
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.height = object.height ?? 0;
    message.elevation = object.elevation ?? 0;
    message.attitudePitch = object.attitudePitch ?? 0;
    message.attitudeRoll = object.attitudeRoll ?? 0;
    message.attitudeHead = object.attitudeHead ?? 0;
    message.homeDistance = object.homeDistance ?? 0;
    message.homeLatitude = object.homeLatitude ?? 0;
    message.homeLongitude = object.homeLongitude ?? 0;
    message.windSpeed = object.windSpeed ?? 0;
    message.windDirection = object.windDirection ?? 0;
    message.gear = object.gear ?? 0;
    message.totalFlightTime = (object.totalFlightTime !== undefined && object.totalFlightTime !== null)
      ? Duration.fromPartial(object.totalFlightTime)
      : undefined;
    message.totalFlightDistance = object.totalFlightDistance ?? 0;
    message.storage = (object.storage !== undefined && object.storage !== null)
      ? Storage.fromPartial(object.storage)
      : undefined;
    message.positionState = (object.positionState !== undefined && object.positionState !== null)
      ? DroneOSD_PositionState.fromPartial(object.positionState)
      : undefined;
    message.totalFlightSorties = object.totalFlightSorties ?? 0;
    message.maintainStatus = (object.maintainStatus !== undefined && object.maintainStatus !== null)
      ? DroneOSD_MaintainStatus.fromPartial(object.maintainStatus)
      : undefined;
    message.nightLightsState = object.nightLightsState ?? 0;
    message.heightLimit = object.heightLimit ?? 0;
    message.obstacleAvoidance = (object.obstacleAvoidance !== undefined && object.obstacleAvoidance !== null)
      ? DroneOSD_ObstacleAvoidance.fromPartial(object.obstacleAvoidance)
      : undefined;
    message.gimbalIndex = (object.gimbalIndex !== undefined && object.gimbalIndex !== null)
      ? DroneOSD_GimbalIndex.fromPartial(object.gimbalIndex)
      : undefined;
    message.ridState = object.ridState ?? false;
    message.isNearAreaLimit = object.isNearAreaLimit ?? 0;
    message.isNearHeightLimit = object.isNearHeightLimit ?? 0;
    message.activationTime = object.activationTime ?? undefined;
    message.videoType = object.videoType ?? "";
    return message;
  },
};

function createBaseDroneOSD_DroneCamera(): DroneOSD_DroneCamera {
  return {
    remainPhotoNum: 0,
    remainRecordDuration: undefined,
    recordTime: undefined,
    payloadIndex: "",
    cameraMode: 0,
    photoState: 0,
    screenSplitEnable: false,
    recordingState: 0,
    zoomFactor: 0,
    irZoomFactor: 0,
    liveviewWorldRegion: undefined,
    photoStorageSettings: [],
    videoStorageSettings: [],
  };
}

export const DroneOSD_DroneCamera: MessageFns<DroneOSD_DroneCamera> = {
  encode(message: DroneOSD_DroneCamera, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.remainPhotoNum !== 0) {
      writer.uint32(8).int32(message.remainPhotoNum);
    }
    if (message.remainRecordDuration !== undefined) {
      Duration.encode(message.remainRecordDuration, writer.uint32(18).fork()).join();
    }
    if (message.recordTime !== undefined) {
      Duration.encode(message.recordTime, writer.uint32(26).fork()).join();
    }
    if (message.payloadIndex !== "") {
      writer.uint32(34).string(message.payloadIndex);
    }
    if (message.cameraMode !== 0) {
      writer.uint32(40).int32(message.cameraMode);
    }
    if (message.photoState !== 0) {
      writer.uint32(48).int32(message.photoState);
    }
    if (message.screenSplitEnable !== false) {
      writer.uint32(56).bool(message.screenSplitEnable);
    }
    if (message.recordingState !== 0) {
      writer.uint32(64).int32(message.recordingState);
    }
    if (message.zoomFactor !== 0) {
      writer.uint32(73).double(message.zoomFactor);
    }
    if (message.irZoomFactor !== 0) {
      writer.uint32(81).double(message.irZoomFactor);
    }
    if (message.liveviewWorldRegion !== undefined) {
      DroneOSD_LiveviewWorldRegion.encode(message.liveviewWorldRegion, writer.uint32(90).fork()).join();
    }
    for (const v of message.photoStorageSettings) {
      writer.uint32(98).string(v!);
    }
    for (const v of message.videoStorageSettings) {
      writer.uint32(106).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD_DroneCamera {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD_DroneCamera();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.remainPhotoNum = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.remainRecordDuration = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.recordTime = Duration.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.payloadIndex = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cameraMode = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.photoState = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.screenSplitEnable = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.recordingState = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.zoomFactor = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.irZoomFactor = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.liveviewWorldRegion = DroneOSD_LiveviewWorldRegion.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.photoStorageSettings.push(reader.string());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.videoStorageSettings.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD_DroneCamera {
    return {
      remainPhotoNum: isSet(object.remainPhotoNum) ? globalThis.Number(object.remainPhotoNum) : 0,
      remainRecordDuration: isSet(object.remainRecordDuration)
        ? Duration.fromJSON(object.remainRecordDuration)
        : undefined,
      recordTime: isSet(object.recordTime) ? Duration.fromJSON(object.recordTime) : undefined,
      payloadIndex: isSet(object.payloadIndex) ? globalThis.String(object.payloadIndex) : "",
      cameraMode: isSet(object.cameraMode) ? cameraModeFromJSON(object.cameraMode) : 0,
      photoState: isSet(object.photoState) ? photoStateFromJSON(object.photoState) : 0,
      screenSplitEnable: isSet(object.screenSplitEnable) ? globalThis.Boolean(object.screenSplitEnable) : false,
      recordingState: isSet(object.recordingState) ? recordingStateFromJSON(object.recordingState) : 0,
      zoomFactor: isSet(object.zoomFactor) ? globalThis.Number(object.zoomFactor) : 0,
      irZoomFactor: isSet(object.irZoomFactor) ? globalThis.Number(object.irZoomFactor) : 0,
      liveviewWorldRegion: isSet(object.liveviewWorldRegion)
        ? DroneOSD_LiveviewWorldRegion.fromJSON(object.liveviewWorldRegion)
        : undefined,
      photoStorageSettings: globalThis.Array.isArray(object?.photoStorageSettings)
        ? object.photoStorageSettings.map((e: any) => globalThis.String(e))
        : [],
      videoStorageSettings: globalThis.Array.isArray(object?.videoStorageSettings)
        ? object.videoStorageSettings.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: DroneOSD_DroneCamera): unknown {
    const obj: any = {};
    if (message.remainPhotoNum !== 0) {
      obj.remainPhotoNum = Math.round(message.remainPhotoNum);
    }
    if (message.remainRecordDuration !== undefined) {
      obj.remainRecordDuration = Duration.toJSON(message.remainRecordDuration);
    }
    if (message.recordTime !== undefined) {
      obj.recordTime = Duration.toJSON(message.recordTime);
    }
    if (message.payloadIndex !== "") {
      obj.payloadIndex = message.payloadIndex;
    }
    if (message.cameraMode !== 0) {
      obj.cameraMode = cameraModeToJSON(message.cameraMode);
    }
    if (message.photoState !== 0) {
      obj.photoState = photoStateToJSON(message.photoState);
    }
    if (message.screenSplitEnable !== false) {
      obj.screenSplitEnable = message.screenSplitEnable;
    }
    if (message.recordingState !== 0) {
      obj.recordingState = recordingStateToJSON(message.recordingState);
    }
    if (message.zoomFactor !== 0) {
      obj.zoomFactor = message.zoomFactor;
    }
    if (message.irZoomFactor !== 0) {
      obj.irZoomFactor = message.irZoomFactor;
    }
    if (message.liveviewWorldRegion !== undefined) {
      obj.liveviewWorldRegion = DroneOSD_LiveviewWorldRegion.toJSON(message.liveviewWorldRegion);
    }
    if (message.photoStorageSettings?.length) {
      obj.photoStorageSettings = message.photoStorageSettings;
    }
    if (message.videoStorageSettings?.length) {
      obj.videoStorageSettings = message.videoStorageSettings;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD_DroneCamera>, I>>(base?: I): DroneOSD_DroneCamera {
    return DroneOSD_DroneCamera.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD_DroneCamera>, I>>(object: I): DroneOSD_DroneCamera {
    const message = createBaseDroneOSD_DroneCamera();
    message.remainPhotoNum = object.remainPhotoNum ?? 0;
    message.remainRecordDuration = (object.remainRecordDuration !== undefined && object.remainRecordDuration !== null)
      ? Duration.fromPartial(object.remainRecordDuration)
      : undefined;
    message.recordTime = (object.recordTime !== undefined && object.recordTime !== null)
      ? Duration.fromPartial(object.recordTime)
      : undefined;
    message.payloadIndex = object.payloadIndex ?? "";
    message.cameraMode = object.cameraMode ?? 0;
    message.photoState = object.photoState ?? 0;
    message.screenSplitEnable = object.screenSplitEnable ?? false;
    message.recordingState = object.recordingState ?? 0;
    message.zoomFactor = object.zoomFactor ?? 0;
    message.irZoomFactor = object.irZoomFactor ?? 0;
    message.liveviewWorldRegion = (object.liveviewWorldRegion !== undefined && object.liveviewWorldRegion !== null)
      ? DroneOSD_LiveviewWorldRegion.fromPartial(object.liveviewWorldRegion)
      : undefined;
    message.photoStorageSettings = object.photoStorageSettings?.map((e) => e) || [];
    message.videoStorageSettings = object.videoStorageSettings?.map((e) => e) || [];
    return message;
  },
};

function createBaseDroneOSD_LiveviewWorldRegion(): DroneOSD_LiveviewWorldRegion {
  return { left: 0, top: 0, right: 0, bottom: 0 };
}

export const DroneOSD_LiveviewWorldRegion: MessageFns<DroneOSD_LiveviewWorldRegion> = {
  encode(message: DroneOSD_LiveviewWorldRegion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.left !== 0) {
      writer.uint32(9).double(message.left);
    }
    if (message.top !== 0) {
      writer.uint32(17).double(message.top);
    }
    if (message.right !== 0) {
      writer.uint32(25).double(message.right);
    }
    if (message.bottom !== 0) {
      writer.uint32(33).double(message.bottom);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD_LiveviewWorldRegion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD_LiveviewWorldRegion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.left = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.top = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.right = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.bottom = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD_LiveviewWorldRegion {
    return {
      left: isSet(object.left) ? globalThis.Number(object.left) : 0,
      top: isSet(object.top) ? globalThis.Number(object.top) : 0,
      right: isSet(object.right) ? globalThis.Number(object.right) : 0,
      bottom: isSet(object.bottom) ? globalThis.Number(object.bottom) : 0,
    };
  },

  toJSON(message: DroneOSD_LiveviewWorldRegion): unknown {
    const obj: any = {};
    if (message.left !== 0) {
      obj.left = message.left;
    }
    if (message.top !== 0) {
      obj.top = message.top;
    }
    if (message.right !== 0) {
      obj.right = message.right;
    }
    if (message.bottom !== 0) {
      obj.bottom = message.bottom;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD_LiveviewWorldRegion>, I>>(base?: I): DroneOSD_LiveviewWorldRegion {
    return DroneOSD_LiveviewWorldRegion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD_LiveviewWorldRegion>, I>>(object: I): DroneOSD_LiveviewWorldRegion {
    const message = createBaseDroneOSD_LiveviewWorldRegion();
    message.left = object.left ?? 0;
    message.top = object.top ?? 0;
    message.right = object.right ?? 0;
    message.bottom = object.bottom ?? 0;
    return message;
  },
};

function createBaseDroneOSD_DistanceLimitStatus(): DroneOSD_DistanceLimitStatus {
  return { state: false, distanceLimit: 0, isNearDistanceLimit: false };
}

export const DroneOSD_DistanceLimitStatus: MessageFns<DroneOSD_DistanceLimitStatus> = {
  encode(message: DroneOSD_DistanceLimitStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== false) {
      writer.uint32(8).bool(message.state);
    }
    if (message.distanceLimit !== 0) {
      writer.uint32(16).int32(message.distanceLimit);
    }
    if (message.isNearDistanceLimit !== false) {
      writer.uint32(24).bool(message.isNearDistanceLimit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD_DistanceLimitStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD_DistanceLimitStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.state = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.distanceLimit = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isNearDistanceLimit = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD_DistanceLimitStatus {
    return {
      state: isSet(object.state) ? globalThis.Boolean(object.state) : false,
      distanceLimit: isSet(object.distanceLimit) ? globalThis.Number(object.distanceLimit) : 0,
      isNearDistanceLimit: isSet(object.isNearDistanceLimit) ? globalThis.Boolean(object.isNearDistanceLimit) : false,
    };
  },

  toJSON(message: DroneOSD_DistanceLimitStatus): unknown {
    const obj: any = {};
    if (message.state !== false) {
      obj.state = message.state;
    }
    if (message.distanceLimit !== 0) {
      obj.distanceLimit = Math.round(message.distanceLimit);
    }
    if (message.isNearDistanceLimit !== false) {
      obj.isNearDistanceLimit = message.isNearDistanceLimit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD_DistanceLimitStatus>, I>>(base?: I): DroneOSD_DistanceLimitStatus {
    return DroneOSD_DistanceLimitStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD_DistanceLimitStatus>, I>>(object: I): DroneOSD_DistanceLimitStatus {
    const message = createBaseDroneOSD_DistanceLimitStatus();
    message.state = object.state ?? false;
    message.distanceLimit = object.distanceLimit ?? 0;
    message.isNearDistanceLimit = object.isNearDistanceLimit ?? false;
    return message;
  },
};

function createBaseDroneOSD_PositionState(): DroneOSD_PositionState {
  return { isFixed: 0, quality: 0, gpsNumber: 0, rtkNumber: 0 };
}

export const DroneOSD_PositionState: MessageFns<DroneOSD_PositionState> = {
  encode(message: DroneOSD_PositionState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isFixed !== 0) {
      writer.uint32(8).int32(message.isFixed);
    }
    if (message.quality !== 0) {
      writer.uint32(16).int32(message.quality);
    }
    if (message.gpsNumber !== 0) {
      writer.uint32(24).int32(message.gpsNumber);
    }
    if (message.rtkNumber !== 0) {
      writer.uint32(32).int32(message.rtkNumber);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD_PositionState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD_PositionState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isFixed = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.quality = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.gpsNumber = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.rtkNumber = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD_PositionState {
    return {
      isFixed: isSet(object.isFixed) ? fixingStateFromJSON(object.isFixed) : 0,
      quality: isSet(object.quality) ? positionQualityFromJSON(object.quality) : 0,
      gpsNumber: isSet(object.gpsNumber) ? globalThis.Number(object.gpsNumber) : 0,
      rtkNumber: isSet(object.rtkNumber) ? globalThis.Number(object.rtkNumber) : 0,
    };
  },

  toJSON(message: DroneOSD_PositionState): unknown {
    const obj: any = {};
    if (message.isFixed !== 0) {
      obj.isFixed = fixingStateToJSON(message.isFixed);
    }
    if (message.quality !== 0) {
      obj.quality = positionQualityToJSON(message.quality);
    }
    if (message.gpsNumber !== 0) {
      obj.gpsNumber = Math.round(message.gpsNumber);
    }
    if (message.rtkNumber !== 0) {
      obj.rtkNumber = Math.round(message.rtkNumber);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD_PositionState>, I>>(base?: I): DroneOSD_PositionState {
    return DroneOSD_PositionState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD_PositionState>, I>>(object: I): DroneOSD_PositionState {
    const message = createBaseDroneOSD_PositionState();
    message.isFixed = object.isFixed ?? 0;
    message.quality = object.quality ?? 0;
    message.gpsNumber = object.gpsNumber ?? 0;
    message.rtkNumber = object.rtkNumber ?? 0;
    return message;
  },
};

function createBaseDroneOSD_MaintainStatus(): DroneOSD_MaintainStatus {
  return { maintainStatusArray: [] };
}

export const DroneOSD_MaintainStatus: MessageFns<DroneOSD_MaintainStatus> = {
  encode(message: DroneOSD_MaintainStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.maintainStatusArray) {
      DroneOSD_MaintainStatusStruct.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD_MaintainStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD_MaintainStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.maintainStatusArray.push(DroneOSD_MaintainStatusStruct.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD_MaintainStatus {
    return {
      maintainStatusArray: globalThis.Array.isArray(object?.maintainStatusArray)
        ? object.maintainStatusArray.map((e: any) => DroneOSD_MaintainStatusStruct.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DroneOSD_MaintainStatus): unknown {
    const obj: any = {};
    if (message.maintainStatusArray?.length) {
      obj.maintainStatusArray = message.maintainStatusArray.map((e) => DroneOSD_MaintainStatusStruct.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD_MaintainStatus>, I>>(base?: I): DroneOSD_MaintainStatus {
    return DroneOSD_MaintainStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD_MaintainStatus>, I>>(object: I): DroneOSD_MaintainStatus {
    const message = createBaseDroneOSD_MaintainStatus();
    message.maintainStatusArray =
      object.maintainStatusArray?.map((e) => DroneOSD_MaintainStatusStruct.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDroneOSD_MaintainStatusStruct(): DroneOSD_MaintainStatusStruct {
  return {
    state: 0,
    lastMaintainType: 0,
    lastMaintainTime: undefined,
    lastMaintainFlightTime: 0,
    lastMaintainFlightSorties: 0,
  };
}

export const DroneOSD_MaintainStatusStruct: MessageFns<DroneOSD_MaintainStatusStruct> = {
  encode(message: DroneOSD_MaintainStatusStruct, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.state !== 0) {
      writer.uint32(8).int32(message.state);
    }
    if (message.lastMaintainType !== 0) {
      writer.uint32(16).int32(message.lastMaintainType);
    }
    if (message.lastMaintainTime !== undefined) {
      Timestamp.encode(toTimestamp(message.lastMaintainTime), writer.uint32(26).fork()).join();
    }
    if (message.lastMaintainFlightTime !== 0) {
      writer.uint32(32).int32(message.lastMaintainFlightTime);
    }
    if (message.lastMaintainFlightSorties !== 0) {
      writer.uint32(40).int32(message.lastMaintainFlightSorties);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD_MaintainStatusStruct {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD_MaintainStatusStruct();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.state = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.lastMaintainType = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastMaintainTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.lastMaintainFlightTime = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.lastMaintainFlightSorties = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD_MaintainStatusStruct {
    return {
      state: isSet(object.state) ? globalThis.Number(object.state) : 0,
      lastMaintainType: isSet(object.lastMaintainType) ? globalThis.Number(object.lastMaintainType) : 0,
      lastMaintainTime: isSet(object.lastMaintainTime) ? fromJsonTimestamp(object.lastMaintainTime) : undefined,
      lastMaintainFlightTime: isSet(object.lastMaintainFlightTime)
        ? globalThis.Number(object.lastMaintainFlightTime)
        : 0,
      lastMaintainFlightSorties: isSet(object.lastMaintainFlightSorties)
        ? globalThis.Number(object.lastMaintainFlightSorties)
        : 0,
    };
  },

  toJSON(message: DroneOSD_MaintainStatusStruct): unknown {
    const obj: any = {};
    if (message.state !== 0) {
      obj.state = Math.round(message.state);
    }
    if (message.lastMaintainType !== 0) {
      obj.lastMaintainType = Math.round(message.lastMaintainType);
    }
    if (message.lastMaintainTime !== undefined) {
      obj.lastMaintainTime = message.lastMaintainTime.toISOString();
    }
    if (message.lastMaintainFlightTime !== 0) {
      obj.lastMaintainFlightTime = Math.round(message.lastMaintainFlightTime);
    }
    if (message.lastMaintainFlightSorties !== 0) {
      obj.lastMaintainFlightSorties = Math.round(message.lastMaintainFlightSorties);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD_MaintainStatusStruct>, I>>(base?: I): DroneOSD_MaintainStatusStruct {
    return DroneOSD_MaintainStatusStruct.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD_MaintainStatusStruct>, I>>(
    object: I,
  ): DroneOSD_MaintainStatusStruct {
    const message = createBaseDroneOSD_MaintainStatusStruct();
    message.state = object.state ?? 0;
    message.lastMaintainType = object.lastMaintainType ?? 0;
    message.lastMaintainTime = object.lastMaintainTime ?? undefined;
    message.lastMaintainFlightTime = object.lastMaintainFlightTime ?? 0;
    message.lastMaintainFlightSorties = object.lastMaintainFlightSorties ?? 0;
    return message;
  },
};

function createBaseDroneOSD_ObstacleAvoidance(): DroneOSD_ObstacleAvoidance {
  return { horizon: false, upside: false, downside: false };
}

export const DroneOSD_ObstacleAvoidance: MessageFns<DroneOSD_ObstacleAvoidance> = {
  encode(message: DroneOSD_ObstacleAvoidance, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.horizon !== false) {
      writer.uint32(8).bool(message.horizon);
    }
    if (message.upside !== false) {
      writer.uint32(16).bool(message.upside);
    }
    if (message.downside !== false) {
      writer.uint32(24).bool(message.downside);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD_ObstacleAvoidance {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD_ObstacleAvoidance();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.horizon = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.upside = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.downside = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD_ObstacleAvoidance {
    return {
      horizon: isSet(object.horizon) ? globalThis.Boolean(object.horizon) : false,
      upside: isSet(object.upside) ? globalThis.Boolean(object.upside) : false,
      downside: isSet(object.downside) ? globalThis.Boolean(object.downside) : false,
    };
  },

  toJSON(message: DroneOSD_ObstacleAvoidance): unknown {
    const obj: any = {};
    if (message.horizon !== false) {
      obj.horizon = message.horizon;
    }
    if (message.upside !== false) {
      obj.upside = message.upside;
    }
    if (message.downside !== false) {
      obj.downside = message.downside;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD_ObstacleAvoidance>, I>>(base?: I): DroneOSD_ObstacleAvoidance {
    return DroneOSD_ObstacleAvoidance.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD_ObstacleAvoidance>, I>>(object: I): DroneOSD_ObstacleAvoidance {
    const message = createBaseDroneOSD_ObstacleAvoidance();
    message.horizon = object.horizon ?? false;
    message.upside = object.upside ?? false;
    message.downside = object.downside ?? false;
    return message;
  },
};

function createBaseDroneOSD_GimbalIndex(): DroneOSD_GimbalIndex {
  return {
    gimbalPitch: 0,
    gimbalRoll: 0,
    gimbalYaw: 0,
    measureTargetLongitude: 0,
    measureTargetLatitude: 0,
    measureTargetDistance: 0,
    measureTargetErrorState: 0,
    payloadIndex: "",
    zoomFactor: 0,
    thermalCurrentPaletteStyle: 0,
    thermalSupportedPaletteStyles: [],
    thermalGainMode: 0,
    thermalIsothermState: 0,
    thermalIsothermUpperLimit: 0,
    thermalIsothermLowerLimit: 0,
    thermalGlobalTemperatureMin: 0,
    thermalGlobalTemperatureMax: 0,
  };
}

export const DroneOSD_GimbalIndex: MessageFns<DroneOSD_GimbalIndex> = {
  encode(message: DroneOSD_GimbalIndex, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.gimbalPitch !== 0) {
      writer.uint32(9).double(message.gimbalPitch);
    }
    if (message.gimbalRoll !== 0) {
      writer.uint32(17).double(message.gimbalRoll);
    }
    if (message.gimbalYaw !== 0) {
      writer.uint32(25).double(message.gimbalYaw);
    }
    if (message.measureTargetLongitude !== 0) {
      writer.uint32(33).double(message.measureTargetLongitude);
    }
    if (message.measureTargetLatitude !== 0) {
      writer.uint32(41).double(message.measureTargetLatitude);
    }
    if (message.measureTargetDistance !== 0) {
      writer.uint32(49).double(message.measureTargetDistance);
    }
    if (message.measureTargetErrorState !== 0) {
      writer.uint32(56).int32(message.measureTargetErrorState);
    }
    if (message.payloadIndex !== "") {
      writer.uint32(66).string(message.payloadIndex);
    }
    if (message.zoomFactor !== 0) {
      writer.uint32(73).double(message.zoomFactor);
    }
    if (message.thermalCurrentPaletteStyle !== 0) {
      writer.uint32(80).int32(message.thermalCurrentPaletteStyle);
    }
    writer.uint32(90).fork();
    for (const v of message.thermalSupportedPaletteStyles) {
      writer.int32(v);
    }
    writer.join();
    if (message.thermalGainMode !== 0) {
      writer.uint32(96).int32(message.thermalGainMode);
    }
    if (message.thermalIsothermState !== 0) {
      writer.uint32(104).int32(message.thermalIsothermState);
    }
    if (message.thermalIsothermUpperLimit !== 0) {
      writer.uint32(112).int32(message.thermalIsothermUpperLimit);
    }
    if (message.thermalIsothermLowerLimit !== 0) {
      writer.uint32(120).int32(message.thermalIsothermLowerLimit);
    }
    if (message.thermalGlobalTemperatureMin !== 0) {
      writer.uint32(129).double(message.thermalGlobalTemperatureMin);
    }
    if (message.thermalGlobalTemperatureMax !== 0) {
      writer.uint32(137).double(message.thermalGlobalTemperatureMax);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DroneOSD_GimbalIndex {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDroneOSD_GimbalIndex();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.gimbalPitch = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.gimbalRoll = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.gimbalYaw = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.measureTargetLongitude = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.measureTargetLatitude = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.measureTargetDistance = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.measureTargetErrorState = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.payloadIndex = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.zoomFactor = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.thermalCurrentPaletteStyle = reader.int32();
          continue;
        }
        case 11: {
          if (tag === 88) {
            message.thermalSupportedPaletteStyles.push(reader.int32());

            continue;
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.thermalSupportedPaletteStyles.push(reader.int32());
            }

            continue;
          }

          break;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.thermalGainMode = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.thermalIsothermState = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.thermalIsothermUpperLimit = reader.int32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.thermalIsothermLowerLimit = reader.int32();
          continue;
        }
        case 16: {
          if (tag !== 129) {
            break;
          }

          message.thermalGlobalTemperatureMin = reader.double();
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.thermalGlobalTemperatureMax = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DroneOSD_GimbalIndex {
    return {
      gimbalPitch: isSet(object.gimbalPitch) ? globalThis.Number(object.gimbalPitch) : 0,
      gimbalRoll: isSet(object.gimbalRoll) ? globalThis.Number(object.gimbalRoll) : 0,
      gimbalYaw: isSet(object.gimbalYaw) ? globalThis.Number(object.gimbalYaw) : 0,
      measureTargetLongitude: isSet(object.measureTargetLongitude)
        ? globalThis.Number(object.measureTargetLongitude)
        : 0,
      measureTargetLatitude: isSet(object.measureTargetLatitude) ? globalThis.Number(object.measureTargetLatitude) : 0,
      measureTargetDistance: isSet(object.measureTargetDistance) ? globalThis.Number(object.measureTargetDistance) : 0,
      measureTargetErrorState: isSet(object.measureTargetErrorState)
        ? globalThis.Number(object.measureTargetErrorState)
        : 0,
      payloadIndex: isSet(object.payloadIndex) ? globalThis.String(object.payloadIndex) : "",
      zoomFactor: isSet(object.zoomFactor) ? globalThis.Number(object.zoomFactor) : 0,
      thermalCurrentPaletteStyle: isSet(object.thermalCurrentPaletteStyle)
        ? globalThis.Number(object.thermalCurrentPaletteStyle)
        : 0,
      thermalSupportedPaletteStyles: globalThis.Array.isArray(object?.thermalSupportedPaletteStyles)
        ? object.thermalSupportedPaletteStyles.map((e: any) => globalThis.Number(e))
        : [],
      thermalGainMode: isSet(object.thermalGainMode) ? globalThis.Number(object.thermalGainMode) : 0,
      thermalIsothermState: isSet(object.thermalIsothermState) ? globalThis.Number(object.thermalIsothermState) : 0,
      thermalIsothermUpperLimit: isSet(object.thermalIsothermUpperLimit)
        ? globalThis.Number(object.thermalIsothermUpperLimit)
        : 0,
      thermalIsothermLowerLimit: isSet(object.thermalIsothermLowerLimit)
        ? globalThis.Number(object.thermalIsothermLowerLimit)
        : 0,
      thermalGlobalTemperatureMin: isSet(object.thermalGlobalTemperatureMin)
        ? globalThis.Number(object.thermalGlobalTemperatureMin)
        : 0,
      thermalGlobalTemperatureMax: isSet(object.thermalGlobalTemperatureMax)
        ? globalThis.Number(object.thermalGlobalTemperatureMax)
        : 0,
    };
  },

  toJSON(message: DroneOSD_GimbalIndex): unknown {
    const obj: any = {};
    if (message.gimbalPitch !== 0) {
      obj.gimbalPitch = message.gimbalPitch;
    }
    if (message.gimbalRoll !== 0) {
      obj.gimbalRoll = message.gimbalRoll;
    }
    if (message.gimbalYaw !== 0) {
      obj.gimbalYaw = message.gimbalYaw;
    }
    if (message.measureTargetLongitude !== 0) {
      obj.measureTargetLongitude = message.measureTargetLongitude;
    }
    if (message.measureTargetLatitude !== 0) {
      obj.measureTargetLatitude = message.measureTargetLatitude;
    }
    if (message.measureTargetDistance !== 0) {
      obj.measureTargetDistance = message.measureTargetDistance;
    }
    if (message.measureTargetErrorState !== 0) {
      obj.measureTargetErrorState = Math.round(message.measureTargetErrorState);
    }
    if (message.payloadIndex !== "") {
      obj.payloadIndex = message.payloadIndex;
    }
    if (message.zoomFactor !== 0) {
      obj.zoomFactor = message.zoomFactor;
    }
    if (message.thermalCurrentPaletteStyle !== 0) {
      obj.thermalCurrentPaletteStyle = Math.round(message.thermalCurrentPaletteStyle);
    }
    if (message.thermalSupportedPaletteStyles?.length) {
      obj.thermalSupportedPaletteStyles = message.thermalSupportedPaletteStyles.map((e) => Math.round(e));
    }
    if (message.thermalGainMode !== 0) {
      obj.thermalGainMode = Math.round(message.thermalGainMode);
    }
    if (message.thermalIsothermState !== 0) {
      obj.thermalIsothermState = Math.round(message.thermalIsothermState);
    }
    if (message.thermalIsothermUpperLimit !== 0) {
      obj.thermalIsothermUpperLimit = Math.round(message.thermalIsothermUpperLimit);
    }
    if (message.thermalIsothermLowerLimit !== 0) {
      obj.thermalIsothermLowerLimit = Math.round(message.thermalIsothermLowerLimit);
    }
    if (message.thermalGlobalTemperatureMin !== 0) {
      obj.thermalGlobalTemperatureMin = message.thermalGlobalTemperatureMin;
    }
    if (message.thermalGlobalTemperatureMax !== 0) {
      obj.thermalGlobalTemperatureMax = message.thermalGlobalTemperatureMax;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DroneOSD_GimbalIndex>, I>>(base?: I): DroneOSD_GimbalIndex {
    return DroneOSD_GimbalIndex.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DroneOSD_GimbalIndex>, I>>(object: I): DroneOSD_GimbalIndex {
    const message = createBaseDroneOSD_GimbalIndex();
    message.gimbalPitch = object.gimbalPitch ?? 0;
    message.gimbalRoll = object.gimbalRoll ?? 0;
    message.gimbalYaw = object.gimbalYaw ?? 0;
    message.measureTargetLongitude = object.measureTargetLongitude ?? 0;
    message.measureTargetLatitude = object.measureTargetLatitude ?? 0;
    message.measureTargetDistance = object.measureTargetDistance ?? 0;
    message.measureTargetErrorState = object.measureTargetErrorState ?? 0;
    message.payloadIndex = object.payloadIndex ?? "";
    message.zoomFactor = object.zoomFactor ?? 0;
    message.thermalCurrentPaletteStyle = object.thermalCurrentPaletteStyle ?? 0;
    message.thermalSupportedPaletteStyles = object.thermalSupportedPaletteStyles?.map((e) => e) || [];
    message.thermalGainMode = object.thermalGainMode ?? 0;
    message.thermalIsothermState = object.thermalIsothermState ?? 0;
    message.thermalIsothermUpperLimit = object.thermalIsothermUpperLimit ?? 0;
    message.thermalIsothermLowerLimit = object.thermalIsothermLowerLimit ?? 0;
    message.thermalGlobalTemperatureMin = object.thermalGlobalTemperatureMin ?? 0;
    message.thermalGlobalTemperatureMax = object.thermalGlobalTemperatureMax ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
